import React from 'react';
import { foodsImage } from '../data/content';
const pillars = [{
  title: 'Limpiamos el terreno',
  text: 'Retiramos los detonantes que mantienen tu intestino inflamado día tras día.'
}, {
  title: 'Optimizamos tus enzimas',
  text: 'Preparamos tu digestión para que los alimentos dejen de fermentar y pesar.'
}, {
  title: 'Calmamos el sistema nervioso',
  text: 'Bajamos el cortisol para que tu cuerpo suelte lo que no necesita, de forma natural.'
}];
export function Mechanism() {
  return <section className="bg-teal-deep text-white" data-id="element-120" data-mp="13jydkmvpmssd">
      <div className="mx-auto max-w-6xl px-6 py-16 lg:py-24" data-id="element-121" data-mp="18i9mmve6kz9j">
        <div className="max-w-3xl" data-id="element-122" data-mp="18gyhos901lgu">
          <p className="text-sm font-semibold text-teal-soft" data-id="element-123" data-mp="1d8zssaufl65a">
            El mecanismo único
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-5xl" data-id="element-124" data-mp="ftvpehux26z1">
            Mecanismo de Reseteo Digestivo (MRD)
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/80" data-id="element-125" data-mp="kqc8uyr67x5s">
            A diferencia de las dietas tradicionales, el Método Vientre Plano
            21D se enfoca en desactivar la respuesta inflamatoria del cuerpo.
            Aquí no contamos calorías.
          </p>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-center" data-id="element-126" data-mp="fkps1f4vjxbk">
          <ol className="space-y-8" data-id="element-127" data-mp="bkyxd0c88x1r">
            {pillars.map((pillar, i) => <li key={pillar.title} className="flex gap-5" data-id="element-128" data-mp="6mxd4c32erop" data-mpi={i}>
                <span aria-hidden="true" className="mt-1 font-display text-xl font-semibold text-gold" data-id="element-129" data-mp="1mi23r699w9w">
                  0{i + 1}
                </span>
                <div data-id="element-130" data-mp="3os93abzb5fbe">
                  <h3 className="font-display text-xl font-semibold" data-id="element-131" data-mp="3ot2a1cy9o4tj">
                    {pillar.title}
                  </h3>
                  <p className="mt-2 max-w-prose leading-relaxed text-white/75" data-id="element-132" data-mp="1qzvabrhho4ga">
                    {pillar.text}
                  </p>
                </div>
              </li>)}
          </ol>

          <img src={foodsImage} alt="Alimentos anti-inflamatorios ordenados sobre una mesa: jengibre, menta, limón, papaya, pepino y semillas de chía" className="w-full rounded-[2rem] object-cover" loading="lazy" data-id="element-133" data-mp="3gh0aqhlazazz" />
        </div>
      </div>
    </section>;
}